/// <reference path="../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var TaskTranslations = /** @class */ (function () {
        function TaskTranslations() {
        }
        TaskTranslations.config = function ($translateProvider) {
            var _a;
            var keys = ap.Constants.translationKeys.shell;
            var englishTable = (_a = {},
                _a[keys.login] = 'Login',
                _a[keys.logo] = 'AutoPoint Reporting',
                _a[keys.logout] = 'Logout',
                _a[keys.greeting] = 'Welcome',
                _a[keys.selectLang] = 'Select your language',
                _a[keys.selectLocation] = 'Select Location',
                _a);
            $translateProvider.translations('en', englishTable);
        };
        return TaskTranslations;
    }());
    app.TaskTranslations = TaskTranslations;
    angular.module('app')
        .config(['$translateProvider', TaskTranslations.config]);
})(app || (app = {}));
